import React, { useRef } from 'react';
import styled from 'styled-components';
import { useHotkeys } from 'react-hotkeys-hook';

import magnifierIcon from './magnifier.svg';

const SearchWrapper = styled.div`
	background-color: #FFF;
	padding: 0 5% 13px 5%;
	position: relative;
`;

const SearchInput = styled.input`
	padding: 12px 0;
	width: 100%;
	text-indent: 44px;
	font-size: 13px;
	line-height: 15px;
	border: 1px solid #D5D7DB;
`;

const SearchHotkeyHint = styled.div`
	position: absolute;
	z-index: 1;
	right: 5%;
	top: 7px;
	line-height: 24px;
	border: solid 1px #CCC;
	color: #CCC;
	margin-right: 10px;
	font-size: 12px;
	width: 24px;
	height: 24px;
	text-align: center;
	user-select: none;
`;

const Icon = styled.img`
	width: 24px;
	height: 24px;
	position: absolute;
	z-index: 1;
	left: 5%;
	top: 7px;
	margin-left: 10px;
`;

const hotkeyFilter = event => {
	// Only '/' key outside the input
	return event && event.key === '/' && event.target.tagName.toLowerCase() !== 'input';
}

export default ({ value, onSearch }) => {

	const input = useRef(null);

	useHotkeys('*', () => {
		input.current.focus();
	}, {
		keydown: false,
		keyup: true,
		filter: hotkeyFilter
	});

	return (
		<SearchWrapper>
			<Icon src={magnifierIcon} alt="Search"/>
			<SearchInput
				value={value}
				onChange={e => onSearch(e.target.value)}
				placeholder="What are you looking for?"
				ref={input}
			/>
			<SearchHotkeyHint
				title="Press / to start searching"
				onClick={() => input.current.focus()}
			>/</SearchHotkeyHint>
		</SearchWrapper>
	);
};
